import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/OurStory.css"; // make sure you have your CSS file here
import StoryImage from "../assets/images/Our Story.jpg";
import { useNavigate } from "react-router-dom";

const OurStorySection = () => {
    const navigate = useNavigate();
  useEffect(() => {
    const elements = document.querySelectorAll(".story-image-wrapper, .story-content");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <section className="our-story-section py-5">
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* Image Section */}
          <div className="col-md-6 mb-4 mb-md-0 ps-0">
            <div className="story-image-wrapper slide-from-left">
              <img src={StoryImage} alt="Our Story" className="story-image" />
            </div>
          </div>

          {/* Text Section */}
          <div className="col-md-6 pe-5 ps-md-5">
            <div className="story-content slide-from-right">
              <h3 className="story-title mb-3">
                What Is <span>Our Story</span>
              </h3>
              <p className="story-text mb-4">
                Biopharmacieaa was founded with a simple belief — that{" "}
                <strong className="me-2">science has the power to transform everyday health.</strong>
                In a world where skin and hair concerns are often addressed only at the
                surface, we envisioned a company that looks deeper: into the biology of
                the skin, follicle, the immune system, and the skin barrier itself.
              </p>

              <a  className="btn-read-more" onClick={() => navigate("/about")}>
                <span>Read More</span>
                <span className="btn-arrow" aria-hidden="true">
                  ➜
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStorySection;
